import { render, staticRenderFns } from "./starRate.vue?vue&type=template&id=13af371c&scoped=true&"
import script from "./starRate.vue?vue&type=script&lang=js&"
export * from "./starRate.vue?vue&type=script&lang=js&"
import style0 from "./starRate.vue?vue&type=style&index=0&id=13af371c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13af371c",
  null
  
)

export default component.exports